export default __webpack_public_path__ + "static/logo_white-b3dfbe906e0e0b68c6727083d210b314.webp";